<div class="main-group">
	<!--			-->
	<!-- Item Count -->
	<!--			-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="label-item-total">A total of {{ this.lstPrintItems.length }} item(s) will be printed.</label>
		</div>
	</div>

	<!--				   -->
	<!-- Filter items text -->
	<!--				   -->
	<div class="main-group-item" [style.display]="StockInUseDesc == '' ? 'none' : 'flex'">
		<div class="main-group-item-center">
			<label class="label-item-stock"
				>Current items in the printer are using card stock [{{ StockInUseDesc }}]. The items with this card stock will only be printed.</label
			>
		</div>
	</div>

	<!-- 				 	 -->
	<!-- Sort Order Selector -->
	<!-- 				 	 -->
	<div class="main-group-item">
		<div class="selector-item">
			<div class="selector-label-div">
				<label class="label-item">Print Sort Order</label>
			</div>

			<div style="margin-left: 10px; width: 300px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="SortOrderSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedSortOrder"
					(ngModelChange)="onSortOrderChange($event)"
				>
					<option *ngFor="let r of lstSortOrder" [ngValue]="r">
						{{ r.SortDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!--				   -->
	<!-- Filter items text -->
	<!--				   -->
	<div class="main-group-item" [style.display]="isStaffMode == true ? 'none' : 'flex'">
		<div class="main-group-item-center">
			<label class="label-item-total">Filter items by</label>
		</div>
	</div>

	<!-- 				  -->
	<!-- Academy Selector -->
	<!-- 				  -->
	<div class="main-group-item" [style.display]="isStaffMode == true ? 'none' : 'block'">
		<div class="selector-item">
			<div class="selector-label-div">
				<label class="label-item">Academy</label>
			</div>

			<div style="margin-left: 10px; width: 300px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="AcademySelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedAcademy"
					(ngModelChange)="onAcademyChange($event)"
				>
					<option *ngFor="let r of lstAcademy" [ngValue]="r">
						{{ r.AcademyDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!-- 				  	 -->
	<!-- GradeLevel Selector -->
	<!-- 				 	 -->
	<div class="main-group-item" [style.display]="isStaffMode == true ? 'none' : 'block'">
		<div class="selector-item">
			<div class="selector-label-div">
				<label class="label-item">Grade</label>
			</div>

			<div style="margin-left: 10px; width: 300px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="GradeLevelSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedGradeLevel"
					(ngModelChange)="onGradeLevelChange($event)"
				>
					<option *ngFor="let r of lstGradeLevel" [ngValue]="r">
						{{ r.GradeLevelDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!-- 				   -->
	<!-- Homeroom Selector -->
	<!-- 				   -->
	<div class="main-group-item" [style.display]="isStaffMode == true ? 'none' : 'block'">
		<div class="selector-item">
			<div class="selector-label-div">
				<label class="label-item">Homeroom</label>
			</div>

			<div style="margin-left: 10px; width: 300px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select class="form-control" name="HomeroomSelector" [(ngModel)]="SelectedHomeroom" (ngModelChange)="onHomeroomChange($event)">
					<option *ngFor="let r of lstHomeroom" [ngValue]="r">
						{{ r.Homeroom }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!--	   -->
	<!-- Notes -->
	<!--	   -->
	<div class="main-group-item">
		<div style="margin-top: 10px">
			<label class="label-item">Note:</label>
			<label style="margin-left: 10px"
				>Any print queue records that were selected that did not have the status of [Review Pending] or [Printed] have been prefiltered.</label
			>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" [disabled]="isBusy == true" (click)="onPrint()">Ok</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
